module.exports = __webpack_public_path__ + "img/3.f48787f2.webp";